/**
 * Skip links — visually hidden link bar that becomes visible on focus.
 * Rendered as the first focusable content in the app layout.
 * Satisfies WCAG 2.4.1 Bypass Blocks.
 */
export function SkipLinks() {
  return (
    <div className="skip-links">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <a href="#side-nav" className="skip-link">
        Skip to navigation
      </a>
    </div>
  );
}
